module.exports = {"StatusCode":200,"Payload":[{"record":{},"hostedZoneId":"some-id","zone":{"DelegationSet":{"NameServers":["n1.nameserver.com","n2.nameserver.com","n3.nameserver.com","n4.nameserver.com"]}}}]}


//////////////////
// WEBPACK FOOTER
// ./src/payloads/aws/lambda/mocks/transferDomain.json
// module id = RGXk
// module chunks = 0